import axios from 'axios'

export default {
    channels() {
        return axios.get('/api/channels');
    },

    gameTypes() {
        return axios.get('/api/game-types');
    },

    findChannel(code) {
        return axios.post('/api/find-channel',{code: code})
    }
}